export const date = {
    dateNoDayNoTime: (data) => {
       return new Date(data).toLocaleDateString('id-ID', { month: 'long', year: 'numeric', day: 'numeric'})  
     },

     dateNoDayWithTime: (data) => {
      return new Date(data).toLocaleDateString('id-ID', { month: 'long', year: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'})  
    },

    dateDiff: (startingDate, endingDate) => {
      let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
      if (!endingDate) {
        endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
      }
      let endDate = new Date(endingDate);
      if (startDate > endDate) {
        return '-';
        console.log(startDate > endDate,);
        const swap = startDate;
        startDate = endDate;
        endDate = swap;
      }
      const startYear = startDate.getFullYear();
      const february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
      const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    
      let yearDiff = endDate.getFullYear() - startYear;
      let monthDiff = endDate.getMonth() - startDate.getMonth();
      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }
      let dayDiff = endDate.getDate() - startDate.getDate();
      if (dayDiff < 0) {
        if (monthDiff > 0) {
          monthDiff--;
        } else {
          yearDiff--;
          monthDiff = 11;
        }
        dayDiff += daysInMonth[startDate.getMonth()];
      }
    
      return yearDiff + ' Tahun ' + monthDiff + ' Bulan ' + dayDiff + ' Hari';
    },
    now(){
      return new Date().toLocaleDateString('id-ID', { month: 'long', year: 'numeric', day: 'numeric'})  
    }
 }